import React from 'react';
import WarehouseOpsPage from './WarehouseOpsPage';
export default function ReturnsReceiving() {
  return <WarehouseOpsPage mode="return" title="Returns Receiving" subtitle="Reconcile failed deliveries and returned packages" />;
}
